import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getPluginStatsEnabled } from '../../../redux/modules/auth';

import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

const headCells = [
  {
    id: 'name',
    label: 'Name'
  },
  {
    id: 'layout',
    label: 'Layout'
  },
  {
    id: 'plays',
    label: 'Plays'
  },
  {
    id: 'impressions',
    label: 'Impressions'
  },
  {
    id: 'date',
    label: 'Created Date'
  }
];

export const VpPluginsTableHead = ({ showStats }) => {
  const finalHeadCells = showStats
    ? headCells
    : headCells.filter((col) => col?.id !== 'plays' && col?.id !== 'impressions');

  return (
    <TableHead>
      <TableRow>
        {finalHeadCells.map((cell) => (
          <TableCell key={cell.id}>{cell.label}</TableCell>
        ))}
        <TableCell padding="checkbox"></TableCell>
      </TableRow>
    </TableHead>
  );
};

VpPluginsTableHead.propTypes = {
  showStats: PropTypes.bool
};

const mapStateToProps = (state) => ({
  showStats: getPluginStatsEnabled(state)
});

export default connect(mapStateToProps)(VpPluginsTableHead);



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginsTable/VpPluginsTableHead.jsx